<template>
    <a-form-item
        :label="$t('form-label.select-official')" 
        :style="{ display: 'inline-block' }"
        :help="help"
        :validate-status="validateStatus">
        
        <a-select
            style="width: 100% !important"
            :value="selectedOfficial"
            :disabled="isLoading"
            :loading="isLoading"
            :filter-option="false"
            :not-found-content="isLoading ? undefined : null"
            class="form-input"
            show-search
            placeholder="Select Official"
            @search="filterOfficials"
            @change="onChangeOfficialSelection">
            <a-spin v-if="isLoading" slot="notFoundContent" size="large" />

            <a-select-option v-for="item in officials" :key="item.id" :value="item.id">
                <span role="img" style="margin-right: 20px;">
                    <a-avatar shape="square" :src="item.imageUrl" />
                </span>
                {{ item.name }}
            </a-select-option>

        </a-select>

    </a-form-item>
</template>

<script>
import { host, officialsClient } from '../../api/config.js';
import { mapState } from "pinia";
import { useAuthStore } from '../../stores/auth-store.js';

export default {
    props: {
        value: {
            type: String,
            required: true,
        },
        help: {
            type: String,
            default: ''
        },
        validateStatus: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            isLoading: false,
            selectedOfficial: '',
            officials: [],
            allOfficials: []
        }
    },
    computed: {
        ...mapState(useAuthStore, [ 'currentUser','profile']),
        isOfficial() {
            return (this.currentUser && this.currentUser.roles && this.currentUser.roles.includes('OFFICIAL'))
        },
    },
    methods: {
        onChangeOfficialSelection(e) {
            // this.value = e;
            this.selectedOfficial = e;
            // this.selectedOfficialId = e;
            this.$emit('input', this.selectedOfficial);
        },
        filterOfficials(input) {
            this.officials = this.allOfficials.filter(o => o.name.toLowerCase().includes(input.toLowerCase()));
        },
    },
    mounted() {
        this.isLoading = true;
        this.selectedOfficial = this.value;
        officialsClient.fetchAllOfPage({ page: 1, size: 20 }).then(res => {
            if (!res.networkError && res.body && res.body.list) {
                res.body.list.forEach(o => {
                    if (!o.imageUrl || o.imageUrl.trim().length == 0)
                        o.imageUrl = '/images/default-avatar.jpg';
                    else
                        o.imageUrl = host + o.imageUrl;
                });
                if (this.isOfficial){
                    this.allOfficials = res.body.list.filter(o => o.id == this.profile.id);
                    this.officials = res.body.list.filter(o => o.id == this.profile.id);
                }else {
                    this.allOfficials = res.body.list;
                    this.officials = res.body.list;
                }
            } else {
                /* TODO: show error */
            }
            this.isLoading = false;
        });
    }
}
</script>